import { all } from 'redux-saga/effects';

import fetchElevatorState from './fetchFloorActivity';

export default function* () {
    yield all([fetchElevatorState()]);
}
